import React from 'react';
import './QueueStat.scss';

export interface QueueStatProps {
  value: number | string;
  label: string;
  colorOverride?: string;
  className?: string;
}

export const QueueStat: React.FC<QueueStatProps> = ({
  value,
  label,
  colorOverride,
  className = ''
}) => {
  return (
    <div
      className={`cmx-queue-stat ${className}`.trim()}
      data-testid="queue-stat"
    >
      <span
        className="cmx-queue-stat__value"
        style={colorOverride ? { color: colorOverride } : undefined}
        data-testid="queue-stat-value"
      >
        {value}
      </span>
      <span className="cmx-queue-stat__label" data-testid="queue-stat-label">
        {label}
      </span>
    </div>
  );
};

QueueStat.displayName = 'QueueStat';
export default QueueStat;
